export default {
  'Choose File': '選擇文件',
  'Please paste a URL': '輸入一個影片URL鏈接',
  'Loading': '加載中',
  'Analyzing': '分析中',
  'Try a sample': '試用範例',
  'Sorry, error occurs when analyzing the URL.': '抱歉，URL解析出錯了。',
}